module.exports = __webpack_public_path__ + "img/20191008160517360截图20191008143554801.de7545aa.jpg";